import InputNumber from 'antd/es/input-number';
import type { InputNumberRef } from '@rc-component/input-number';
import { ComponentProps, forwardRef } from 'react';
import clsx from 'clsx';

import './OpInputNumber.scss';

interface OpInputNumberProps
  extends ComponentProps<typeof InputNumber<string | number>> {
  testId?: string;
  gtm?: string;
}

/**
 * OpInputNumber is a wrapper around Ant Design's InputNumber component.
 * It provides a numeric input with increment/decrement controls and validation.
 *
 * Use this component for numeric inputs in forms, such as quantities, prices, or any numerical values.
 * Supports min/max values, step increments, and formatting options.
 *
 * @example
 * <OpInputNumber
 *   min={0}
 *   max={100}
 *   step={1}
 *   value={value}
 *   onChange={handleChange}
 * />
 *
 */
export const OpInputNumber = forwardRef<InputNumberRef, OpInputNumberProps>(
  (
    { testId = 'op-input-number', className, gtm, ...inputNumberProps },
    ref,
  ) => {
    return (
      <InputNumber
        ref={ref}
        className={clsx('op-input-number', className)}
        data-testid={testId}
        data-gtm={gtm}
        {...inputNumberProps}
      />
    );
  },
);
